import { Option } from "../../common/models/flow.dto";
import { Validators } from "@angular/forms";
import { Observable } from "rxjs";
//import { GridOptions } from '@ag-grid-enterprise/all-modules';
import { GridOptions } from "ag-grid-community";


export class DialogButton {
    click: (args: any) => {};
    isConfirm: boolean;
    text: string;    

    constructor(text: string, isConfirm: boolean, click: any) {
        this.text = text;
        this.click = click;
        this.isConfirm = isConfirm;
    }
}

export class Dialog {
    buttons: DialogButton[];
    controls: DialogControl[];
    formName: string;
    gridOptions: GridOptions;
    hasParam: boolean = false;
    isTabular: boolean = false;
    message: string
    rows: any[];
    protected visible: boolean = false;

    get visibility(): boolean {
        return this.visible;
    }

    constructor(message: string, buttons: DialogButton[], hasParam: boolean = false, controls: DialogControl[] = []) {
        this.message = message;
        this.buttons = buttons;
        this.hasParam = hasParam;
        this.controls = controls;
    }

    setControls(ctrls: DialogControl[]): void {
        this.controls = ctrls;
    }

    setFormName(name: string): void {
        this.formName = name;
    }

    setTabulation(options: GridOptions, data: any[]) {
        this.gridOptions = options;
        this.rows = data;
        this.isTabular = true;
    }

    toggleDialog(show: boolean): void {        
        this.visible = show;
    }

    updateButtons(buttonSet: DialogButton[]): void {
        this.buttons = buttonSet;
    }
}

export class DialogControl {
    controlDependencies: ControlDependency[];
    controlTargets: TargettedControl[] = [];
    id: string;    
    label: string;
    options: Option[];
    validators: Validators[];
    type: DialogControlType    
    value: any;

    constructor(controlId: string, title: string, defaultValue: any, type: DialogControlType, selectionOptions: Option[], validators: Validators[]) {
        this.id = controlId;
        this.label = title;
        this.value = defaultValue;
        this.type = type;
        this.options = selectionOptions;
        this.validators = validators;
        this.controlDependencies = [];
    }

    addControlDependency(source: string, validValues: any[], dependencyType: PropertyDependency): void {
        let dependency: ControlDependency = {
            controlName: source,
            dependentValues: validValues,
            property: dependencyType
        } as ControlDependency;
        this.controlDependencies.push(dependency);
    }

   

    addTargettedControl(target: string, optionSet: DialogOptionSet[] = []): void {
        let controlTarget: TargettedControl = {
            controlName: target,
            optionSets:  optionSet
        } as TargettedControl;
        this.controlTargets.push(controlTarget);
    }

}


export interface ControlDependency {
    controlName: string;
    dependentValues: any[];
    property: PropertyDependency;
}

export interface TargettedControl {
    controlName: string;
    optionSets: DialogOptionSet[];
}

export interface PreventBooleanFromChanging {
    whenValueIs: boolean;
}

export enum PropertyDependency {
    Enabled,
    Visible,
    CanToggleCheckbox
}

export enum DialogControlType {
    Text,
    Dropdown,
    Number,
    Checkbox,
    TextEditor,
    Date
}

export class DialogOptionSet {
    value: string;
    set: Option[];
    booleanValue?: boolean;
}
